import { useMemo } from 'react';

import { useUserIsConfirmed, useUserIsSelfService } from '@hcs/auth';
import { combineUseQueryResult } from '@hcs/utils';

export const useUserSelfServiceConfirmed = () => {
  const userIsConfirmedQuery = useUserIsConfirmed();
  const userIsSelfServiceQuery = useUserIsSelfService();
  const combinedQuery = combineUseQueryResult([
    userIsConfirmedQuery,
    userIsSelfServiceQuery,
  ]);

  const isSelfServiceAndConfirmed = useMemo(() => {
    if (combinedQuery.isSuccess) {
      const { data: userIsConfirmed } = userIsConfirmedQuery;
      const { data: userIsSelfService } = userIsSelfServiceQuery;
      return userIsConfirmed && userIsSelfService;
    }
    return undefined;
  }, [userIsConfirmedQuery, userIsSelfServiceQuery, combinedQuery.isSuccess]);

  return {
    ...combinedQuery,
    data: isSelfServiceAndConfirmed,
  };
};
